module.exports = __webpack_public_path__ + "static/media/1023174.301d0cba.png";